import type { TooltipProps } from '@mui/material/Tooltip';

export const sidebarTooltipProps: Partial<TooltipProps> = {
  placement: 'right',
  arrow: true,
  enterDelay: 300,
  leaveDelay: 100,
  disableInteractive: false,
};
